import React from 'react';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  title: 'TITLE',
  createdBy: 'CREATED BY',
};

const additionalProps = {};

const HeaderCourseMaterials = ({
  onChange,
  value: selectedValue,
}) => {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map(value => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value]) || {}}
        />
      ))}
      <th></th>
    </tr>
  );
}

export default HeaderCourseMaterials;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/CourseMaterials/Headers.jsx